var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.item.ivans_status === 'pending')?_c('div',[_vm._v(" Pending ")]):(_vm.item.ivans_status === 'received')?_c('div',[_vm._v(" Downloaded ")]):_c('div',[_vm._v(" Manual ")])])}
var staticRenderFns = []

export { render, staticRenderFns }